import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Navbar from "./Navbar";
import "./SignIn.css";

/* ================= API BASE ================= */
const normalizeBase = (value) =>
  String(value || "").trim().replace(/\/+$/, "");

const ensureApiSuffix = (base) => {
  const clean = normalizeBase(base);

  if (!clean) return "http://localhost:5000/api";

  return clean.endsWith("/api") ? clean : `${clean}/api`;
};

const API_BASE = ensureApiSuffix(
  process.env.REACT_APP_API_BASE || "http://localhost:5000"
);

/* ================= COMPONENT ================= */
function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();

  const alreadyCalledRef = useRef(false);

  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (alreadyCalledRef.current) return;

    alreadyCalledRef.current = true;

    const safeToken = String(token || "").trim();

    if (!safeToken) {
      setStatus("error");
      setMessage("Invalid verification link.");
      return;
    }

    const verifyEmail = async () => {
      try {
        setStatus("loading");
        setMessage("Verifying your email...");

        const res = await fetch(
          `${API_BASE}/auth/verify-email/${encodeURIComponent(safeToken)}`,
          {
            method: "GET",
            cache: "no-store",
          }
        );

        const data = await res.json().catch(() => ({}));

        if (!res.ok || data?.success === false) {
          setStatus("error");
          setMessage(data?.message || "Verification failed or link expired.");
          return;
        }

        setStatus("success");
        setMessage(data?.message || "Your email has been verified successfully.");

        setTimeout(() => {
          navigate("/signin", { replace: true });
        }, 2000);
      } catch {
        setStatus("error");
        setMessage("Server error. Please try again.");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <>
      <Navbar />

      <section className="signin-section">
        <div className="signin-container">
          <div className="signin-left">
            <h1>Email Verification 📧</h1>

            <p>
              Please wait while we verify your email address. This usually takes
              only a few seconds.
            </p>

            <div className="signin-features">
              <div>✔ Secure email verification</div>
              <div>✔ Account activation</div>
              <div>✔ Login after verification</div>
            </div>
          </div>

          <div className="signin-card">
            <h2>Verification Status</h2>

            {status === "loading" ? (
              <div className="auth-alert">{message || "Verifying your email..."}</div>
            ) : null}

            {status === "success" ? (
              <div className="auth-alert auth-success">
                {message}
                <p>Redirecting to sign in...</p>
              </div>
            ) : null}

            {status === "error" ? (
              <div className="auth-alert auth-error">
                {message}
                <div style={{ marginTop: "15px" }}>
                  <Link to="/signin">Go to Sign In</Link>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    </>
  );
}

export default VerifyEmail;